import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { AuthModal } from '@zoopla/authentication/modal';
import { useAuthModal } from '@zoopla/authentication/use-auth-modal';
import { NudgesTracker } from '@zoopla/nudges-tracker';
import { useUser } from '@zoopla/user';
import { selectPageNumber } from '@zoopla/redux-reducer-search-results';

export const SituationLoggedOutModal = ({ pageType }: { pageType: string }) => {
    const pageNumber = useSelector(selectPageNumber);
    const [isAuthModalShowing, openAuthModal, closeAuthModal] = useAuthModal();
    const { loggedIn, loading } = useUser();

    useEffect(() => {
        if (
            loading ||
            loggedIn ||
            typeof window === undefined ||
            sessionStorage.getItem('your-situation-modal-lsrp') === 'true' ||
            localStorage.getItem('your-situation-modal-lsrp-completed') ===
                'true' ||
            pageNumber !== 1
        ) {
            return;
        }

        const numberForSale =
            NudgesTracker.getNumberOfPages({ type: '/for-sale/details/' }) ?? 0;
        const numberToRent =
            NudgesTracker.getNumberOfPages({ type: '/to-rent/details/' }) ?? 0;

        if (numberForSale >= 2 && pageType === 'for-sale') {
            openAuthModal(null);
            sessionStorage.setItem('your-situation-modal-lsrp', 'true');
            return;
        }

        if (numberToRent >= 2 && pageType === 'to-rent') {
            openAuthModal(null);
            sessionStorage.setItem('your-situation-modal-lsrp', 'true');
            return;
        }
    }, [loading, loggedIn, openAuthModal, pageType, pageNumber]);

    if (pageType !== 'for-sale' && pageType !== 'to-rent') {
        return null;
    }

    return (
        <AuthModal
            heading="Join Zoopla and tailor your experience"
            isShowing={isAuthModalShowing}
            actionAfterAuth={{
                action: closeAuthModal,
                eventLabel: '',
                pageType
            }}
            close={closeAuthModal}
            initialMode="situation-quick-access"
        />
    );
};
